/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
import axios from 'axios';
import { logout } from 'src/redux/slices/authJwt'

const axiosInstance = axios.create();
const ANON_KEY = process.env.REACT_APP_ANON_KEY;
const webAPI_URL = process.env.REACT_APP_GET_TOKEN_URL;
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem('accessToken');
  // const userIdlocal = Number(localStorage.getItem('userId'));
  // console.log("getUserId Axios", userIdlocal);
  // Attach access token
  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  }

  // Append common params
  // config.params = {
  //   ...config.params,
  //   userId: userIdlocal
  // };

  return config;
}, (error) => Promise.reject(error));

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    console.log("🛑 Testing originalRequest error:", error, error.response?.status, originalRequest, originalRequest._retry);

    // Skip retry for token endpoints to avoid infinite loops
    if (originalRequest.url.includes('/user/getAccessToken')) {
      return Promise.reject(error);
    }

    // Handle 401 errors (unauthorized)
    if (error.response?.status === 401) {
      // Check if retry flag is already set
      if (originalRequest._retry) {
        console.log("🛑 Already retried once, rejecting.");
        return Promise.reject(error);
      }

      // Set the retry flag
      originalRequest._retry = true;

      // Check if another refresh process is running
      if (isRefreshing) {
        console.log("🔄 Refresh in progress, queuing request.");
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return axiosInstance(originalRequest);
          })
          .catch(err => Promise.reject(err));
      }

      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");

        // Validate the refresh token
        if (!refreshToken) {
          console.error("🛑 No refresh token found.");
          throw new Error("No refresh token found");
        }

        // Attempt to get a new access token using the refresh token
        const refreshResponse = await axios.post(
          `${webAPI_URL}/user/getAccessToken`,
          { refresh_token: refreshToken },
          {
            headers: { Authorization: `Bearer ${ANON_KEY}` }
          }
        );

        const newAccessToken = refreshResponse?.data?.accessToken;
        console.log("🟢 New Access Token:", newAccessToken);

        if (newAccessToken) {
          localStorage.setItem("accessToken", newAccessToken);
          processQueue(null, newAccessToken);
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return axiosInstance(originalRequest);
        } else {
          throw new Error("No accessToken returned from refresh endpoint");
        }

      } catch (err) {
        console.error("🛑 Token refresh failed:", err.message || err);

        // Properly clear the failed queue
        processQueue(err, null);

        // Dispatch logout action to clear the Redux state
        store.dispatch(logout());

        // Optionally, redirect to login page
        window.location.href = "/login";

      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);



export default axiosInstance;
